import React from 'react';

export default function FormError({ message }) {
    return (
        <div className={`form-group${message ? ' form-group--error' : ''}`}>
            {message && <div className="message message--inline message--error">{message}</div>}
        </div>
    );
}
